<template>
  <app-breadcrumb class="text-primary-950" :items="items" />
</template>

<script lang="ts" setup>
import type { EventView } from "~/business-areas/event/composables/event-view.hook";
import type { BreadcrumbItem } from "~/shared/breadcrumb/breadcrumb.model";

const properties = defineProps<{
  event: EventView;
}>();

const items = computed<BreadcrumbItem[]>(() => {
  return [
    { label: "Tous les événements", to: { name: "events" } },
    { label: properties.event.course.title },
  ];
});
</script>
